import React, { useEffect, useRef } from 'react';
const CONFIG = {
  symbols: [{
    proName: 'OANDA:XAUUSD',
    title: 'XAU/USD'
  }, {
    proName: 'BINANCE:BTCUSDT',
    title: 'BTC/USDT'
  }, {
    proName: 'FOREXCOM:EURUSD',
    title: 'EUR/USD'
  }, {
    proName: 'CAPITALCOM:NAS100',
    title: 'NAS100'
  }, {
    proName: 'CAPITALCOM:SPX500',
    title: 'SPX500'
  }, {
    proName: 'TVC:DXY',
    title: 'DXY'
  }],
  showSymbolLogo: true,
  isTransparent: true,
  displayMode: 'compact',
  colorTheme: 'dark',
  locale: 'en'
};

/** Market tape pinned to the very top of the page — always visible. */
export function TickerTape() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const widget = document.createElement('div');
    widget.className = 'tradingview-widget-container__widget';
    widget.style.height = '100%';
    widget.style.width = '100%';
    container.appendChild(widget);
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify(CONFIG);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, []);
  return <div className="ticker-neon fixed inset-x-0 top-0 z-[60] h-[76px]" data-id="element-183" data-mp="3583lf8bn5m3x">
      <div ref={containerRef} className="tradingview-widget-container h-full" data-id="element-184" data-mp="3swwacktuitp1" />
    </div>;
}